import styles from "./NavTopBarBody.module.scss"
import { NavTopBarBodyProps } from "./NavTopBarBody.types"

export default function NavTopBarBody(props: NavTopBarBodyProps) {
    const { children } = props

    return (
        <div className={styles.base}>
            <div className={styles.container}>{children}</div>
        </div>
    )
}
